export default __webpack_public_path__ + "static/bank-logo-mb-8350a85a8b3c5a93c87120a1291ca17f.png";